import { useEffect, useState } from "react";
import { BellRing, Loader2 } from "lucide-react";
import { TravelTag } from "./TravelStatusPanel";
import { api } from "../lib/api";

const Group = ({ title, rows, tone, testid, late }) => (
  <div className={`rounded-xl border p-3 ${tone}`} data-testid={testid}>
    <p className="mb-2 text-sm font-bold">{title} <span className="font-mono-nums">({rows.length})</span></p>
    {rows.length === 0 ? <p className="text-xs opacity-60">لا أحد</p> : (
      <div className="max-h-72 overflow-y-auto">
        <table className="w-full text-right text-xs">
          <thead className="opacity-70"><tr><th className="p-1">الموظف</th><th className="p-1">الفرع</th><th className="p-1">آخر إجازة</th><th className="p-1">موعد الاستحقاق</th>{late && <th className="p-1">التأخير</th>}</tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.employee_id} className="border-t border-black/5" data-testid={`${testid}-row-${r.employee_id}`}>
                <td className="p-1 font-semibold">{r.name}<TravelTag status={r.travel} />{r.has_pending && <span className="mr-1 rounded bg-amber-100 px-1 text-[10px] text-amber-700">طلب معلّق</span>}</td>
                <td className="p-1">{r.branch || "—"}</td>
                <td className="p-1 font-mono-nums">{r.last_leave || (r.hire_date ? `تعيين ${r.hire_date}` : "—")}</td>
                <td className="p-1 font-mono-nums">{r.due || "—"}</td>
                {late && <td className="p-1 font-bold text-rose-700">{r.months_late} شهر</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);

export const LeaveDueList = () => {
  const [branch, setBranch] = useState("");
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api.leavesDue(branch).then(setD).catch(() => setD({ due_now: [], overdue: [], no_record: [], branches: [] })); }, [branch]);
  return (
    <div className="space-y-3 rounded-2xl border border-slate-200 bg-white p-4" data-testid="leave-due-list">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h4 className="flex items-center gap-2 font-heading font-bold text-slate-800"><BellRing className="h-5 w-5 text-teal-600" /> المستحقون للإجازة {d?.month ? `— ${d.month}` : ""}</h4>
        <select value={branch} onChange={(e) => setBranch(e.target.value)} data-testid="leave-due-branch" className="h-8 rounded-lg border border-slate-200 bg-white px-2 text-xs">
          <option value="">كل الفروع</option>
          {(d?.branches || []).map((b) => <option key={b} value={b}>{b}</option>)}
        </select>
      </div>
      {!d ? <Loader2 className="mx-auto h-5 w-5 animate-spin text-slate-400" /> : (
        <>
          <p className="text-[11px] text-slate-400">الاستحقاق = آخر إجازة (أو تاريخ التعيين) + {d.gap_months} شهرًا حسب إعدادات الشركة.</p>
          <div className="grid gap-3 lg:grid-cols-2">
            <Group title="يحق لهم الإجازة الآن" rows={d.due_now} tone="border-emerald-200 bg-emerald-50/60 text-emerald-900" testid="leave-due-now" />
            <Group title="تجاوزوا موعدهم" rows={d.overdue} tone="border-rose-200 bg-rose-50/60 text-rose-900" testid="leave-overdue" late />
          </div>
          {d.no_record.length > 0 && <Group title="بدون سجل إجازة ولا تاريخ تعيين" rows={d.no_record} tone="border-slate-200 bg-slate-50 text-slate-700" testid="leave-no-record" />}
        </>
      )}
    </div>
  );
};
